import axios from 'axios';
import { postData } from './axiosUtils';

const publisherService = {
  list: (listContentCount: boolean = false) => {
    return axios
      .get(`/api/publisher/list/${listContentCount}`)
      .then((response) => {
        return response.data;
      });
  },
  get: (id: any) => {
    return axios.get(`/api/publisher/details/${id}`).then((response) => {
      return response.data;
    });
  },
  create: (entity: any) => {
    return postData({
      url: `/api/publisher/create`,
      data: entity,
    }).then((response) => {
      return response;
    });
  },
  update: (entity: any) => {
    return postData({
      url: `/api/publisher/update`,
      data: entity,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  delete: (id: any) => {
    return postData({
      url: `/api/publisher/delete/${id}`,
      method: 'DELETE',
    }).then((response) => {
      return response;
    });
  },
};

export default publisherService;
